// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__LEy57","author":"Table_author__1j8Kh","authorImage":"Table_authorImage__1xhPV","unreadRow":"Table_unreadRow__1nrwc"};